
import { defineComponent } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2/dist/sweetalert2.min.js';
import * as Yup from 'yup';
import ApiService from '@/core/services/ApiService';

export default defineComponent({
  name: 'self-trainee-registration',
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      districts: [],
      subDistricts: [],
      subPermanentDistrict: [],
      subHomeSubDistrict: [],
      empDistricts: [],
      empHomeDistricts: [],
      trainee: {
        course_sector: '',
        location: '',
        entity_id: '',
        training_institute_id: '',
        course_info_id: '',
        tranche_id: '',
        batch_info_id: '',
        reference_number: '',
        trainee_name: '',
        gender: '',
        nid: '',
        bcn: '',
        date_of_birth: '',
        present_address: '',
        present_post_code: '',
        present_district: '',
        present_upazilla: '',
        photo: '',
        per_address: '',
        per_post_code: '',
        per_district: '',
        per_upazilla: '',
        home_district: '',
        home_upazilla: '',
        mobile: '',
        email: '',
        alternative_mobile: '',
        religion: '',
        ethnic_group: '',
        highest_class_completed: '',
        highest_class_completed_year: '',
        is_employed: '',
        year_of_experience: '',
        family_monthly_income: '',
        is_physically_challenged: '',
        challenge_remarks: '',
        mother_name: '',
        mother_education_level: '',
        mother_occupation: '',
        father_name: '',
        father_education_level: '',
        father_occupation: '',
        father_annual_income: '',
        have_family_owned_home: '',
        have_family_owned_land: '',
        number_of_siblings: '',
        bank_name: '',
        bank_branch_name: '',
        bank_routing_no: '',
        bank_account_number: '',
        account_type: '',
        x_bank_id: '',
        x_mobile_bankings_id: '',
        x_agent_banking_id: '',
        confirmaccount_no: '',
      },
      url: '',
      email_otp: '',
      trainee_otp: '',
      emailbtnIsDisabled: 0,
      courseSectors: [],
      institutes: [],
      associations: [],
      locations: [],
      tranches: [],
      courses: [],
      batches: [],
      ethnicGroups: [],
      traineeData: [] as any,
      loading: false,
      showEmailVerifyForm: false,
      showOtpVerifyForm: false,
      showNidVerifyForm: false,
      showNidField: false,
      showBCNField: false,
      showTraineeForm: false,
      showtrainingProviderNotice: false,
      course_id: '' as any,
      currentYear: new Date().getFullYear(),
    };
  },
  async created() {
    let data = window.location.search;

    let urlParams = new URLSearchParams(data);
    this.course_id = urlParams.get('course_id');
    console.log(urlParams, this.course_id);
    await this.getCourseSector();
    await this.associationList();
    // await this.getDivision();
    await this.getDistrictForEmp();
    await this.getEthnicGroup();
  },
  methods: {
    async formSubmit() {
      let formData = new FormData();

      formData.set('photo', this.trainee.photo);
      formData.set('self_reg', '1');
      for (var key in this.trainee) {
        formData.set(key, this.trainee[key]);
      }
      this.loading = true;
      await ApiService.post('trainee/trainee_save', formData)
        .then((response) => {
          this.loading = false;
          if (response.status == 200) {
            if (response.data.status == 'error') {
              this.loading = false;
              Swal.fire({
                title: 'Error!',
                html: response.data.message,
                icon: 'error',
                buttonsStyling: false,
                confirmButtonText: 'Close',
                customClass: {
                  confirmButton: 'btn btn-danger',
                },
              });
            } else {
              Swal.fire({
                title: 'Success!',
                text: response.data.data,
                icon: 'success',
                buttonsStyling: false,
                confirmButtonText: 'Ok',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              }).then(() => {
                this.trainee = {
                  course_sector: '',
                  location: '',
                  entity_id: '',
                  training_institute_id: '',
                  course_info_id: '',
                  tranche_id: '',
                  batch_info_id: '',
                  reference_number: '',
                  trainee_name: '',
                  gender: '',
                  nid: '',
                  bcn: '',
                  date_of_birth: '',
                  present_address: '',
                  present_post_code: '',
                  present_district: '',
                  present_upazilla: '',
                  photo: '',
                  per_address: '',
                  per_post_code: '',
                  per_district: '',
                  per_upazilla: '',
                  home_district: '',
                  home_upazilla: '',
                  mobile: '',
                  email: '',
                  alternative_mobile: '',
                  religion: '',
                  ethnic_group: '',
                  highest_class_completed: '',
                  highest_class_completed_year: '',
                  is_employed: '',
                  year_of_experience: '',
                  family_monthly_income: '',
                  is_physically_challenged: '',
                  challenge_remarks: '',
                  mother_name: '',
                  mother_education_level: '',
                  mother_occupation: '',
                  father_name: '',
                  father_education_level: '',
                  father_occupation: '',
                  father_annual_income: '',
                  have_family_owned_home: '',
                  have_family_owned_land: '',
                  number_of_siblings: '',
                  bank_name: '',
                  bank_branch_name: '',
                  bank_routing_no: '',
                  bank_account_number: '',
                  account_type: '',
                  x_bank_id: '',
                  x_mobile_bankings_id: '',
                  x_agent_banking_id: '',
                  confirmaccount_no: '',
                };
                this.$router.push('/sign-up');
              });
            }
          } else {
            let err = '';
            for (const field of Object.keys(response.data.errors)) {
              err += response.data.errors[field][0] + '<br>';
            }
            Swal.fire({
              title: 'Please check all the required field',
              html: err,
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: 'Close',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            });
          }
        })
        .catch(({ response }) => {
          this.loading = false;
          Swal.fire({
            title: 'Unknown error',
            html: response.data.error,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Close',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          });
        });
    },
    traineePhoto(e) {
      this.trainee.photo = e.target.files[0];
      this.url = URL.createObjectURL(this.trainee.photo);
    },
    async getDistrictForEmp() {
      await ApiService.get('trainee/district_list')
        .then((response) => {
          this.empDistricts = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getSubDistrict() {
      await ApiService.get(
        'trainee/upazila_list?district=' + this.trainee.present_district
      )
        .then((response) => {
          this.subDistricts = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getPermanentSubDistrict() {
      await ApiService.get(
        'trainee/upazila_list?district=' + this.trainee.per_district
      )
        .then((response) => {
          this.subPermanentDistrict = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getHomeSubDistrict() {
      await ApiService.get(
        'trainee/upazila_list?district=' + this.trainee.home_district
      )
        .then((response) => {
          this.subHomeSubDistrict = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async associationList() {
      await ApiService.get(
        'trainee/entity_list?district=' +
          this.trainee.location +
          '&course_info_id=' +
          this.trainee.course_info_id
      )
        .then((response) => {
          this.associations = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getCourseSector() {
      await ApiService.get('trainee/course_sector')
        .then((response) => {
          this.courseSectors = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getLocation() {
      await ApiService.get(
        'trainee/district_list?course_info_id=' + this.trainee.course_info_id
      )
        .then((response) => {
          this.locations = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },

    async trainingInstitute() {
      await ApiService.get(
        'trainee/institute_list?entity_id=' +
          this.trainee.entity_id +
          '&district=' +
          this.trainee.location +
          '&course_info_id=' +
          this.trainee.course_info_id
      )
        .then((response) => {
          this.institutes = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getCourseList() {
      await ApiService.get(
        'trainee/course_list?course_sector=' + this.trainee.course_sector
      )
        .then((response) => {
          this.courses = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getEthnicGroup() {
      await ApiService.get('trainee/ethnic_group')
        .then((response) => {
          this.ethnicGroups = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    showEmailVerify() {
      this.showEmailVerifyForm = true;
    },
    async emailVerify() {
      this.emailbtnIsDisabled = 1;
      let data = {
        name: this.trainee.trainee_name,
        mobile: this.trainee.mobile,
        email: this.trainee.email,
      };
      await ApiService.post('trainee/verify_email', data)
        .then((response) => {
          this.loading = false;
          if (response.status == 200) {
            if (response.data.status == 'error') {
              this.loading = false;
              Swal.fire({
                title: 'Error!',
                html: response.data.message,
                icon: 'error',
                buttonsStyling: false,
                confirmButtonText: 'Close',
                customClass: {
                  confirmButton: 'btn btn-danger',
                },
              });
              this.emailbtnIsDisabled = 0;
            } else {
              Swal.fire({
                title: 'Success!',
                text: 'OTP successfully sent to your email.',
                icon: 'success',
                buttonsStyling: false,
                confirmButtonText: 'Ok',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              }).then(() => {
                this.showOtpVerifyForm = true;
                this.email_otp = response.data.data.otp;
              });
            }
          } else {
            let err = '';
            for (const field of Object.keys(response.data.errors)) {
              err += response.data.errors[field][0] + '<br>';
            }
            Swal.fire({
              title: 'Please check all the required field',
              html: err,
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: 'Close',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            });
          }
        })
        .catch(({ response }) => {
          this.loading = false;
          Swal.fire({
            title: 'Unknown error',
            html: response.data.error,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Close',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          });
          console.log(response);
        });
    },
    otpVerify() {
      if (this.email_otp == this.trainee_otp) {
        this.showNidVerifyForm = true;
      } else {
        Swal.fire({
          title: 'Error!',
          html: 'OTP not match.',
          icon: 'error',
          buttonsStyling: false,
          confirmButtonText: 'Close',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        });
      }
    },

    verifyBCN() {
      if (this.trainee.bcn) {
        this.showTraineeForm = true;
      }
    },

    async verifyNid() {
      let nid = this.trainee.nid;
      let nid_digits = nid.toString().length;
      if (nid_digits == 10 || nid_digits == 13 || nid_digits == 17) {
        if (nid_digits == 13) {
          this.checkNidLocalDB(nid);
          const dob = new Date(this.trainee.date_of_birth);
          let year = dob.getFullYear();
          nid = year + nid;
          this.checkNidLocalDB(nid);
        } else {
          this.checkNidLocalDB(nid);
        }
      } else {
        Swal.fire({
          title: 'Error!',
          html: 'NID must be 10/13/17 digits',
          icon: 'error',
          buttonsStyling: false,
          confirmButtonText: 'Close',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        });
      }
    },
    async checkNidLocalDB(nid) {
      await ApiService.get('trainee/nid_search?nid=' + nid)
        .then((response) => {
          if (response.data.data) {
            if (response.data.data.allow_dup_enrollment == 1) {
              this.showTraineeForm = true;
            } else {
              if (response.data.data.registration_number) {
                var msg =
                  'Duplicate trainee exists (Existing Trainee Registration no: ' +
                  response.data.data.registration_number +
                  ')';
              } else {
                var msg =
                  'Duplicate trainee exists (Existing Trainee Reference no: ' +
                  response.data.data.reference_number +
                  ')';
              }
              Swal.fire({
                title: 'Error!',
                html: msg,
                icon: 'error',
                buttonsStyling: false,
                confirmButtonText: 'Close',
                customClass: {
                  confirmButton: 'btn btn-danger',
                },
              });
            }
          } else {
            this.showTraineeForm = true;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    checkDob() {
      if (this.trainee.date_of_birth) {
        let dob = this.trainee.date_of_birth;
        let age = this.getAge(dob);
        if (age < 15) {
          Swal.fire({
            title: 'Error!',
            html: 'Age must be atleast 15 years',
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Close',
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          });
        } else if (age > 19) {
          this.showNidField = true;
        } else {
          this.showNidField = true;
          this.showBCNField = true;
        }
      }
    },

    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
  },
  setup() {
    const TrainerSchema = Yup.object().shape({
      // email: Yup.string()
      //   .email("Must be valid email")
      //   .required()
      //   .label("Email"),
      // //presentDistrict: Yup.string().required().label("Present District"),
      // name: Yup.string().required().label("Name"),
      // father_name: Yup.string().required().label("Father Name"),
      // mother_name: Yup.string().required().label("Mother Name"),
      // trainer_image: Yup.string().required().label("Trainer Photo"),
      // religion: Yup.string().required().label("Religion"),
      // gender: Yup.string().required().label("gender"),
      // mobile: Yup.number().required().min(11).label("Mobile"),
      // ref_id: Yup.number().required().label("Reference Id"),
      // mother_edu: Yup.string().required().label("Mother's Education Level"),
      // mother_occ: Yup.string().required().label("Mother's Occupation"),

      // branchName: Yup.string().required().label("Branch Name"),
      // routingNo: Yup.string().required().label("Routing No"),
      // account_no: Yup.string().required().label("Account Number"),
      // present_districts: Yup.string().required().label("Present District"),
      // permanent_districts: Yup.string().required().label("Permanent District"),
      // permanent_upazilla: Yup.string().required().label("Permanent Upazilla"),
      // present_upazilla: Yup.string().required().label("Present Upazilla"),
      // is_employee: Yup.string().required().label("Is Employee"),
      // is_physically: Yup.string().required().label("Is Physically"),
      // remarks: Yup.string().required().label("Remarks"),
      // passing_year: Yup.string().required().label("Passing Year"),
      // family_own_home: Yup.string().required().label("Family Owned Home"),
      // family_own_land: Yup.string().required().label("Family Owned Land"),
      // bank_account_type: Yup.string().required().label("Bank Account Type"),
      // mobile_bank: Yup.string().required().label("Bank Name"),
      // confirmaccount_no: Yup.string()
      //   .required()
      //   .label("Confirm Account Number"),
      // permanent_districts: Yup.string().required().label("Permanent District"),

      password: Yup.string()
        .required()
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/,
          'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character'
        )
        .label('Password'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], "Password didn't match!")
        .label('Confirm Password'),
    });
    return {
      TrainerSchema,
    };
  },
});
